import { initializeApp } from "firebase/app";
import { initializeAuth, browserLocalPersistence } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import constant from "@/utils/constant";
import { getStorage } from "firebase/storage";

const stagingOptions = {
    apiKey: "AIzaSyAs4AC9St5VX6gGjmE77rxJ7UlNH97fye8",
    authDomain: "aider-staging.firebaseapp.com",
    projectId: "aider-staging",
    storageBucket: "aider-staging.appspot.com",
    messagingSenderId: "522563108219",
    appId: "1:522563108219:web:679934d289d971f90911de",
    measurementId: "G-BQ7NRFP0Q6",
};

const productionOptions = {
    apiKey: "AIzaSyAFwsVSooTPXhD_T0jMZCA1pC1I8vUaWv4",
    authDomain: "aider-production.firebaseapp.com",
    projectId: "aider-production",
    storageBucket: "aider-production.appspot.com",
    messagingSenderId: "528108642299",
    appId: "1:528108642299:web:1e264a49afe64a429c355e",
    measurementId: "G-9BY6DSXF2H",
};

const app = initializeApp(constant.PROD ? productionOptions : stagingOptions);
const auth = initializeAuth(app, { persistence: browserLocalPersistence });
const firestore = getFirestore(app);
const cloudStorage = getStorage();

export { auth, firestore, cloudStorage };
